import SidebarCollapse from "@builder/components/app/SidebarCollapse";
import { EditableProps } from "@builder/components/editable/editableProps";
import DynamicDataSelectorInput from "@builder/components/general/DynamicSelectorInput";
import RadioInput from "@builder/components/general/RadioInput";
import SelectImage from "@builder/components/general/SelectImage";
import { getSelectedNode } from "@builder/store/slices/BuilderSlice/builderSelectors";
import { updateNodeProperty } from "@builder/store/slices/BuilderSlice/builderSlice";
import { setCurrentPopup, setImageState } from "@builder/store/slices/popupSlice";
import { useAppDispatch, useAppSelector } from "@builder/store/store";
import { useState } from "react";
import { useTranslation } from "react-i18next";

const BackgroundImage = ({ parent }: EditableProps) => {
    const dispatch = useAppDispatch();
    const node = useAppSelector(getSelectedNode);
    const [imageType, setImageType] = useState<string>(node?.dynamicData ? "db" : "static");
    const { t } = useTranslation();

    const imageTypeOptions = [
        {
            value: "static",
            img: "/image-icon-thin.svg",
            checked: imageType === "static",
            disabled: !!node?.dynamicData,
            tooltip: t("generalComponents.radioInput.Static")
        },
        { value: "db", img: "/db-icon.svg", checked: imageType === "db", tooltip: t("generalComponents.radioInput.Dynamic") }
    ];

    const imageTypeCallback = (value: string): void => {
        setImageType(value);
    };

    const imageCallback = () => {
        dispatch(setImageState(["backgroundImage"]));
        dispatch(setCurrentPopup("images"));
    };

    const removeImageCallback = () => {
        dispatch(updateNodeProperty({ propertyPath: ["backgroundImage"], value: "", remove: true }));
    };

    return (
        <SidebarCollapse parent={parent} title="Background image">
            <RadioInput groupName="textType" options={imageTypeOptions} callback={imageTypeCallback}></RadioInput>
            {imageType === "static" ? (
                <SelectImage type="image" callback={imageCallback} removeCallback={removeImageCallback} img={node?.backgroundImage} />
            ) : (
                <DynamicDataSelectorInput />
            )}
        </SidebarCollapse>
    );
};

export default BackgroundImage;
